export default () => {
  const wooLoadmore = document.querySelector('.woo-loadmore')
  const wooArchive = document.querySelector('.woo-archive')
  if (!wooLoadmore && !wooArchive) return
  wooLoadmore.addEventListener('click', e => {
    e.preventDefault()
    wooArchive.classList.add('showAll')
    wooLoadmore.remove()
  })
}



// WEBPACK FOOTER //
// ./src/js/_woo-loadmore.js